import { Divider, Hidden, IconButton } from "@material-ui/core";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import PublishIcon from "@material-ui/icons/Publish";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import React, { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import SideBarProps from "./SideBarProps";

export default function SideBar(props: SideBarProps) {
  const drawerWidth = props.drawerWidth;

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      drawer: {
        width: props.menuVisible ? "100%" : drawerWidth,
        flexShrink: 0,
      },
      list: {
        marginTop: 25,
      },
      drawerPaper: {
        marginTop: 84,
        width: props.menuVisible ? "100%" : drawerWidth,
        color: "white",
        backgroundColor: "rgb(20, 59, 89)",
      },
      icon: {
        color: "white",
      },
      // necessary for content to be below app bar
      toolbar: theme.mixins.toolbar,
      content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(3),
      },
    })
  );

  const classes = useStyles();

  const [groups, setGroups] = useState<string[]>();
  useEffect(() => {
    setGroups(props.user?.getSignInUserSession()?.getAccessToken().payload["cognito:groups"]);
  }, [props.user]);

  return (
    <Hidden xsDown={!props.menuVisible}>
      <Drawer
        className={classes.drawer}
        variant="permanent"
        classes={{
          paper: classes.drawerPaper,
        }}
        anchor="right"
      >
        <div>
          <Hidden smUp>
            <IconButton onClick={props.onNavigate}>
              <CloseIcon className={classes.icon} />
            </IconButton>
          </Hidden>
        </div>
        <List className={classes.list}>
          {groups && groups.indexOf("admin") >= 0 && (
            <RouterLink to="/admin" style={{ textDecoration: "none", color: "white" }}>
              <ListItem button key="" onClick={props.onNavigate}>
                <ListItemIcon>
                  <SupervisorAccountIcon className={classes.icon} />
                </ListItemIcon>
                <ListItemText primary="Manage Users" />
              </ListItem>
            </RouterLink>
          )}
          {groups && groups.indexOf("admin") >= 0 && (
            <RouterLink to="/video-upload" style={{ textDecoration: "none", color: "white" }}>
              <ListItem button key="" onClick={props.onNavigate}>
                <ListItemIcon>
                  <PublishIcon className={classes.icon} />
                </ListItemIcon>
                <ListItemText primary="Upload Video" />
              </ListItem>
            </RouterLink>
          )}
          {groups && groups.indexOf("admin") >= 0 && (
            <RouterLink to="/document-upload" style={{ textDecoration: "none", color: "white" }}>
              <ListItem button key="" onClick={props.onNavigate}>
                <ListItemIcon>
                  <PublishIcon className={classes.icon} />
                </ListItemIcon>
                <ListItemText primary="Document Video" />
              </ListItem>
            </RouterLink>
          )}
          <RouterLink to="/workday/employee" style={{ textDecoration: "none", color: "white" }}>
            <ListItem button key="" onClick={props.onNavigate}>
              <ListItemIcon>
                <MenuBookIcon className={classes.icon} />
              </ListItemIcon>
              <ListItemText primary="Employee" />
            </ListItem>
          </RouterLink>
          <RouterLink to="/workday/manager" style={{ textDecoration: "none", color: "white" }}>
            <ListItem button key="" onClick={props.onNavigate}>
              <ListItemIcon>
                <MenuBookIcon className={classes.icon} />
              </ListItemIcon>
              <ListItemText primary="Manager" />
            </ListItem>
          </RouterLink>
          <RouterLink to="/workday/hrbuspartner" style={{ textDecoration: "none", color: "white" }}>
            <ListItem button key="" onClick={props.onNavigate}>
              <ListItemIcon>
                <MenuBookIcon className={classes.icon} />
              </ListItemIcon>
              <ListItemText primary="HR Business Partner" />
            </ListItem>
          </RouterLink>
          <RouterLink to="/workday/ehwc" style={{ textDecoration: "none", color: "white" }}>
            <ListItem button key="" onClick={props.onNavigate}>
              <ListItemIcon>
                <MenuBookIcon className={classes.icon} />
              </ListItemIcon>
              <ListItemText primary="EHWC" />
            </ListItem>
          </RouterLink>
          <RouterLink to="/workday/sdc" style={{ textDecoration: "none", color: "white" }}>
            <ListItem button key="" onClick={props.onNavigate}>
              <ListItemIcon>
                <MenuBookIcon className={classes.icon} />
              </ListItemIcon>
              <ListItemText primary="SDC" />
            </ListItem>
          </RouterLink>
          <RouterLink to="/workday/recruiter" style={{ textDecoration: "none", color: "white" }}>
            <ListItem button key="" onClick={props.onNavigate}>
              <ListItemIcon>
                <MenuBookIcon className={classes.icon} />
              </ListItemIcon>
              <ListItemText primary="Recruiter" />
            </ListItem>
          </RouterLink>
          <RouterLink to="/workday/finance" style={{ textDecoration: "none", color: "white" }}>
            <ListItem button key="" onClick={props.onNavigate}>
              <ListItemIcon>
                <MenuBookIcon className={classes.icon} />
              </ListItemIcon>
              <ListItemText primary="Finance" />
            </ListItem>
          </RouterLink>
          <RouterLink to="/video" style={{ textDecoration: "none", color: "white" }}>
            <ListItem button key="" onClick={props.onNavigate}>
              <ListItemIcon>
                <MenuBookIcon className={classes.icon} />
              </ListItemIcon>
              <ListItemText primary="Catalog" />
            </ListItem>
          </RouterLink>
        </List>
        {/*<List dense>
                    <ListItem button key="">
                        <ListItemText primary="Tag number one" />
                    </ListItem>
                    <ListItem button key="">
                        <ListItemText primary="Tag number two" />
                    </ListItem>
                    <ListItem button key="">
                        <ListItemText primary="Tag number three" />
                    </ListItem>
                    <ListItem button key="">
                        <ListItemText primary="Tag number four" />
                    </ListItem>
                    <ListItem button key="">
                        <ListItemText primary="Tag number five" />
                    </ListItem >
                    <ListItem button key="">
                        <ListItemText primary="Tag number six" />
                    </ListItem>
                </List >*/}
        <Divider />
        <List dense>
          <ListItem button key="" onClick={props.onNavigate}>
            <ListItemText onClick={props.onLogout} primary="Log Out" />
          </ListItem>
        </List>
      </Drawer>
    </Hidden>
  );
}
